/**
 * Model for topic attributes
 */
define([
  "backbone",
  "messaging/messenger",
  "configuration/properties",
  "modules/shared/sortableList/sortableListModel",
], function (Backbone, Messenger, Properties, SortableListModel) {
  var AttributeTypeModel = {};

  AttributeTypeModel.attributeType = Backbone.Model.extend({});

  AttributeTypeModel.attributeTypes = Backbone.Collection.extend({
    model: AttributeTypeModel.attributeType,

    comparator: function (a, b) {
      return Backbone.textComparator(a, b, "type");
    },
  });

  Messenger.reqres.setHandler("fetch:attributeTypes", function (kbId) {
    var attributeTypes = new AttributeTypeModel.attributeTypes();
    attributeTypes.url = Properties.adminRootURL + "/kbs/" + kbId + "/attributeTypes";
    attributeTypes.fetch();
    attributeTypes.on("sync", function () {
      this.sort();
    });
    return attributeTypes;
  });

  return AttributeTypeModel;
});
